import { BatteryModel } from '../models'
import { BatteryOverviewDto } from '../api/dto/battery-overview.dto'
import { ceil, floor } from 'lodash'

const fromDtoToModelTransformer = (dto: BatteryOverviewDto): BatteryModel => ({
  rsoc: dto.batRsoc,
  asoc: dto.batAsoc,
  temperature: { ...dto.batTemperature, values: dto.batTemperature.values.reverse() },
  current: { ...dto.batCurrent },
  voltage: { ...dto.batVoltage },
  chargeCycles: dto.batChargeCycles,
  capacityRemaining: dto.batRc,
  capacityTotal: dto.batFcc,
  countModules: dto.batDcbCount,
  deviceName: dto.batDeviceName,
  dcbType: dto.batDcbType,
  maxVoltage: dto.batMaxBatVoltage,
  cellVoltage: dto.batCellVoltage,
  eodVoltage: dto.batEodVoltage,
  errorCode: dto.batErrorCode,
  firmwareVersion: dto.batFirmwareVersion,
  maxChargeCurrent: dto.batMaxChargeCurrent,
  maxDischargeCurrent: dto.batMaxDischargeCurrent,
  statusCode: dto.batStatusCode,
  terminalVoltage: dto.batTerminalVoltage,
  voltageAdjustment: {
    ...dto.batVoltAdjustment,
    max: floor(dto.batVoltAdjustment.max ?? 0, 1),
    min: ceil(dto.batVoltAdjustment.min ?? 0, 1),
    target: Number(dto.batVoltAdjustment.target?.toFixed(1)) ?? 0,
  },
  batteryListIndex: dto.batIndex,
  paramBatNumber: dto.batParamBatNumber,
  deviceState: {
    inService: dto.batDeviceState?.batDeviceInService || false,
    working: dto.batDeviceState?.batDeviceWorking || false,
    connected: dto.batDeviceState?.batDeviceConnected || false,
  },
})

export default fromDtoToModelTransformer
